module.exports = __webpack_public_path__ + "img/组 129.4e71b648.png";